import React from "react";
import { useQuery } from "react-query";
import { Space, Spin, Tooltip, Typography } from "antd";
import { Common } from "@secondcloset/types";
import { fetchShippingConfigurations } from "../../../../../api/accounts/organization_shipping_configurations";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import * as S from "./styles";

type OrgShippingConfigKey = Common.OrganizationShippingConfigKey;
interface ShippingPreferencesProps {
  organizationId: string;
}
const Text = Typography.Text;

const ShippingPreferences: React.FC<ShippingPreferencesProps> = ({ organizationId }) => {
  const { data: shippingConfigs, isLoading } = useQuery(["organizationShippingConfigs", organizationId], () =>
    fetchShippingConfigurations(organizationId)
  );

  const renderRow = (carrierCode: string) => {
    return <S.Label key={`${carrierCode}`}>{carrierCode}</S.Label>;
  };

  const renderCarriers = (msg: string, configKey: OrgShippingConfigKey, title: string) => {
    const config = shippingConfigs?.find((i) => i.key === configKey);
    return (
      <Space direction="vertical" style={{ marginBottom: 10 }}>
        <div>
          <Text style={{ marginRight: 10 }}>{title}</Text>
          <Tooltip placement="right" title={msg}>
            <ExclamationCircleOutlined style={{ color: "#4a90e2" }} />
          </Tooltip>
        </div>
        <S.IndentedWrapper>
          {config?.value?.sort((a, b) => a.localeCompare(b)).map((carrier) => renderRow(carrier)) || "-"}
        </S.IndentedWrapper>
      </Space>
    );
  };

  const renderPreferredCarriers = () => {
    const msg = "The carriers the merchant prefers to work with";
    const configKey = "whitelist_carrier";
    const title = "Preferred Carriers";
    return renderCarriers(msg, configKey, title);
  };

  const renderExcludeCarriers = () => {
    const msg = "The carriers the merchant does not want to use for shipping orders";
    const configKey = "blacklist_carrier";
    const title = "Exclude Carriers";
    return renderCarriers(msg, configKey, title);
  };

  return (
    <S.Wrapper>
      <S.Header>Shipping Preferences</S.Header>
      <Spin spinning={isLoading}>
        <S.ContentWrapper>
          <Space direction="vertical">
            <S.SubHeader>Carrier Preferences</S.SubHeader>
            {renderPreferredCarriers()}
            {renderExcludeCarriers()}
          </Space>
        </S.ContentWrapper>
      </Spin>
    </S.Wrapper>
  );
};

export default ShippingPreferences;
